var e=class{constructor(){this.type="none";}toJSONObject(){return {type:this.type}}},r=new e;

export { r as a };
